import { PublicClientApplication } from '@azure/msal-browser';

// Configuración de la app registrada en Azure AD (Entra ID) del tenant ESEN.
// clientId y tenantId NO son secretos: viven en el frontend sin problema.
// El flujo es SPA (Authorization Code + PKCE), por eso NO se usa client secret.
export const msalConfig = {
    auth: {
        clientId: 'd36e2892-87b7-4bbf-afcd-21b6fe2105c4',
        authority: 'https://login.microsoftonline.com/6d190339-488f-48c3-bf21-20d5d9832895',
        // Debe coincidir EXACTO con el Redirect URI registrado en Azure.
        // En dev resuelve a http://localhost:3000/ (con barra final, como se registró).
        redirectUri: `${window.location.origin}/`,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

// Permisos delegados que pide la app. Mail.Read = leer el buzón del usuario.
export const loginRequest = {
    scopes: ['User.Read', 'Mail.Read'],
};

// Instancia única (singleton) reutilizada por toda la app.
export const msalInstance = new PublicClientApplication(msalConfig);
